import { fetchEGate } from "../eGateApi";
import { unwrap } from "../../api";
import type { EntityOperation } from "../../api/entity";

/**
 * Gets whether field value for given entity is already used
 *
 * @param target - The entity's `valueUsed` operation, or its plural endpoint name
 *                 (e.g. `users`) for configs that have no generated operations
 * @param field - Name of field to test (e.g. "email")
 * @param value - Value to test
 * @param message - Message if exists
 * @param scope - Scope definition. If not provided, global scope is used
 * @param apiVersion - Only consulted on the endpoint-string path
 */
export async function isValueUsed<TEntity, TValue>(
  target: EntityOperation | string,
  field: keyof TEntity,
  value: TValue,
  message: string,
  scope?: Record<keyof TEntity, unknown>,
  apiVersion?: string
): Promise<void> {
  if (!value) return Promise.resolve();
  const body = { field, value, scope };

  // Rejecting with `message` is what makes this usable straight as an antd validator;
  // a failed *request* resolves, because a uniqueness check that cannot run should not
  // block the form. Both paths keep that.
  const used =
    typeof target === "string"
      ? fetchEGate("POST", `${target}/value-used`, body, undefined, { version: apiVersion }).then((response) =>
          response.status === 200 ? response.json() : false
        )
      : unwrap(target.call({ body }));

  return used.then(
    (isUsed) => (isUsed ? Promise.reject(message) : Promise.resolve()),
    (reason) => {
      console.log(reason);
    }
  );
}
